import { apiClient } from './client';
import type { OntologyVersion } from '@snxt/snxt-onto-share';

// Single definition, shared with the backend, so `version_number: string | null`
// is enforced on both sides. Re-exported for the components already importing it
// from here.
export type { OntologyVersion };

export interface PublishOptions {
  bump?: 'major' | 'minor' | 'patch';
  /** Explicit version override (e.g. "2.0.0"). Wins over `bump` if provided. */
  version?: string;
  release_notes?: string | null;
}

export interface PublishResponse {
  /** Carries the number assigned by this publish. */
  published: OntologyVersion & { version_number: string };
  /** Freshly forked draft: version_number is always null. */
  next_draft: OntologyVersion;
}

export const versionApi = {
  // `signal` is for the publish verification read (useResilientMutation), which needs a much
  // shorter deadline than env.apiTimeout.
  async list(ontologyId: string, signal?: AbortSignal): Promise<OntologyVersion[]> {
    // apiClient.get returns the unwrapped `data` from { success, data }.
    const data = await apiClient.get<{ versions: OntologyVersion[] }>(
      `/api/ontologies/${ontologyId}/versions`,
      { signal }
    );
    return data.versions;
  },

  async publish(ontologyId: string, options: PublishOptions = {}): Promise<PublishResponse> {
    return apiClient.post<PublishResponse>(
      `/api/ontologies/${ontologyId}/versions/publish`,
      options
    );
  },
};

// Made with Bob
